<template>
  <v-card class="elevation-0 transparent">
    <v-tabs v-model="tab" bg-color="transparent" color="primary">
      <v-tab> Channels </v-tab>
      <v-tab> Formats </v-tab>
      <v-tab> Audience </v-tab>
    </v-tabs>

    <v-tabs-window v-model="tab">
      <v-tabs-window-item>
        <ChannelSelector v-model="channels" @update:modelValue="onUpdate" />
      </v-tabs-window-item>
      <v-tabs-window-item>
        <AdPlacementTypeSelector
          multiple
          v-model="formats"
          @update:modelValue="onUpdate"
        />
      </v-tabs-window-item>
      <v-tabs-window-item>
        <CampaignAudience v-model="audiences" @update:modelValue="onUpdate" />
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card>
</template>


<script>
import AdPlacementTypeSelector from "../../molecules/adPlacement/AdPlacementTypeSelector.vue";
import CampaignAudience from "../../molecules/campaign/CampaignAudience.vue";
import ChannelSelector from "../../molecules/channel/ChannelSelector.vue";

export default {
  name: "CampaignTargeting",
  components: {
    CampaignAudience,
    AdPlacementTypeSelector,
    ChannelSelector,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:modelValue"],

  data() {
    return {
      tab: 0,
      channels: [],
      formats: [],
      audiences: [],
    };
  },
  methods: {
    onUpdate() {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        targeting: {
          ...this.modelValue.targeting,
          ...this.audiences,
          channels: this.channels,
          formats: this.formats,
        },
      });
    },
  },
};
</script>